<template>
  <div
    v-if="user"
    class="white_box table_component type_1 report_block report_page"
  >
    <div class="flex items-center mb_8 table_head">
      <h3 class="heading_h4 font_bold mr_auto">
        {{ user.organisation.name }}&apos;s Report Schedules for
        {{ user.active_website.simple_url }}
      </h3>

      <div
        v-if="selected.length && canEditReports"
        class="items_btns"
      >
        <div class="flex items-center wrap">
          <a
            class="btn btn_md primary_btn delete_btn"
            href="javascript:;"
            @click="deleteSelected()"
          >
            <svg
              fill="none"
              height="15"
              viewBox="0 0 14 15"
              width="14"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8125 3.5625L2.1875 3.56251"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                d="M5.6875 6.1875V9.6875"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                d="M8.3125 6.1875V9.6875"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                d="M10.9375 3.5625V11.875C10.9375 11.991 10.8914 12.1023 10.8094 12.1844C10.7273 12.2664 10.616 12.3125 10.5 12.3125H3.5C3.38397 12.3125 3.27269 12.2664 3.19064 12.1844C3.10859 12.1023 3.0625 11.991 3.0625 11.875V3.5625"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                d="M9.1875 3.5625V2.6875C9.1875 2.45544 9.09531 2.23288 8.93122 2.06878C8.76712 1.90469 8.54456 1.8125 8.3125 1.8125H5.6875C5.45544 1.8125 5.23288 1.90469 5.06878 2.06878C4.90469 2.23288 4.8125 2.45544 4.8125 2.6875V3.5625"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
            </svg>
            <span class="p_small font_bold">Delete Schedule{{ selected.length > 1 ? 's' : '' }}</span>
          </a>
        </div>
      </div>
    </div>

    <div class="table_wrapper">
      <table
        id="reports_table"
        class="keywords_table p_small reports_table"
      >
        <thead>
          <tr>
            <td class="sort_title">
              <span>Report name</span>
              <i class="icon arrow_down" />
            </td>
            <!--<td>
              <span>Status</span>
          </td>-->
            <td>
              <span>Created</span>
            </td>
            <td>
              <span>Date Range</span>
            </td>
            <td>
              <span>Comparison Date Range</span>
            </td>
            <td>
              <span>Frequency</span>
            </td>
            <td>
              <span>Last Delivered</span>
            </td>
            <td>
              <span>Next Delivery</span>
            </td>
            <td v-if="canEditReports">
              <span>&nbsp;</span>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="schedule of schedules"
            :key="schedule.id"
            :class="selected.includes(schedule.id) ? 'choosed' : ''"
            @click="selected.includes(schedule.id) ? selected.splice(selected.indexOf(schedule.id),1) : selected.push(schedule.id)"
          >
            <td>
              <div class="flex">
                <div class="checkbox_wrapper report_valid">
                  <input
                    :id="'check_'+schedule.id"
                    type="checkbox"
                  >
                  <label :for="'check_'+schedule.id" />
                </div>
                <span>{{ schedule.report.name }}</span>
              </div>
            </td>
            <td>
              <span>{{ formatDateTime(schedule.created_at) }}</span>
            </td>
            <td>
              <span v-title-case="schedule.date_range" />
            </td>
            <td>
              <span v-title-case="schedule.compare_to" />
            </td>
            <td>
              <span v-title-case="schedule.frequency" />
            </td>
            <td>
              <span>{{ formatDateTime(schedule.last_delivered) }}</span>
            </td>
            <td>
              <div class="flex items-center">
                <span>{{ formatDateTime(schedule.next_delivery) }}</span>
                <span 
                  v-if="schedule.error > 0" 
                  v-tooltip="{
                    content: 'There was an error sending your schedule, and it has now been stopped. To resume sending reports, please delete this schedule and create a new one.',
                    theme: 'dark-blue-tooltip',
                    placement: 'bottom',
                  }"
                  class="ml-2"
                >
                  <svg-vue
                    icon="icons/warning-red"
                    width="16"
                    height="16"
                  />
                </span>
              </div>
            </td>
            <td
              v-if="canEditReports"
              class="action_buttons"
            >
              <a
                class="table_btn edit tooltipster"
                href="javascript:;"
                title="Schedule Settings"
                @click.stop="scheduleSettings(schedule.report_id)"
              >
                <i class="icon settings_icon_white" />
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      v-if="paginate"
      class="action_pagination_wrapper p_x_small"
    >
      <div v-if="paginate.total">
        Showing {{ paginate.from }}-{{ paginate.to }} of <span
          class="total_page"
        >{{ paginate.total }}</span> schedules
      </div>
      <div v-else>
        No results
      </div>
      <div class="action_pagination">
        <a
          v-for="(link, index) in paginate.links"
          :key="index"
          :class="link.active ? 'current_page' : ''"
          href="javascript:;"
          @click="navigatePagination({url: link.url})"
          v-html="link.label"
        />
      </div>
    </div>
  </div>
  <schedule-modal
    v-if="scheduleModal"
    @close="scheduleModal = false"
  />
</template>

<script>
import {mapActions, mapState} from 'vuex';
import moment from 'moment';
import Swal from 'sweetalert2';
import ScheduleModal from '../../builder/modals/ScheduleModal.vue';

export default {
  components: {
    ScheduleModal
  },
  data() {
    return {
      selected: [],
      scheduleModal: false,
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('reportSchedules', ['schedules', 'paginate']),
    canEditReports() {
      return this?.user?.permissions?.reports_permission === 'EDIT' ?? false;
    },
  },
  methods: {
    ...mapActions({
      fetchReport: 'report/fetchReport',
      fetchReports: 'reports/fetchReports',
      fetchSchedules: 'reportSchedules/fetchSchedules',
      deleteSchedules: 'reportSchedules/deleteSchedules',
    }),
    async deleteSelected() {
      Swal.fire({
        title: `Are you sure?`,
        icon: 'warning',
        html: `You are about to delete ${this.selected.length} schedule${this.selected.length > 1 ? 's' : ''}.<br> This action cannot be undone`,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#d33',
        showLoaderOnConfirm: true,
        backdrop: true,
        preConfirm: async () => {
          await this.deleteSchedules(this.selected)
            .then(response => response);
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: `Deleted successfully`,
            icon: 'success'
          });
          this.selected = [];
          this.fetchSchedules();
          this.fetchReports();
        }
      });
    },
    formatDateTime(datetime) {
      if (moment(datetime).isValid()) {
        if (this.user.organisation.operation_country === 'United States') {
          return moment(datetime).format('MM/DD/YYYY HH:mm');
        } else {
          return moment(datetime).format('DD/MM/YYYY HH:mm');
        }
      } else {
        return '-';
      }
    },
    async scheduleSettings(reportID) {
      this.fetchReport({type: 'reports', id: reportID})
          .then(() => {
            this.scheduleModal = true;
          });
    },
  }
}
</script>

<style scoped>
.table_btn {
  color: white;
}

.table_btn.view:hover {
  background-color: #5f49af;
}

.table_btn.view {
  background-color: #8667f7;
}

.table_btn.download:hover {
  background-color: #23cf23;
}

.table_btn.download {
  background-color: #199219;
}

.table_btn.preview:hover {
  background-color: #993c37;
}

.table_btn.preview {
  background-color: #f3625a;
}

a[target="_blank"] {
  padding: 0;
  display: flex;
}

a[target="_blank"]:after {
  background-image: none;
  margin: 0;
  top: 0;
}

.action_buttons {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.items_btns .btn.delete_btn svg path {
  stroke: white;
}

.items_btns .btn.delete_btn span {
  color: white;
}
</style>
